<div class="dialog">

  <app-header-dialog [iconName]="'ballot'">
    Importar
  </app-header-dialog>

  <mat-tab-group>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>info_outline</mat-icon>
        <div>Importar Inscrições</div>
      </ng-template>

      <div class='tab-content'>

        <div class='content'>
          <br>

          <ul>
            <b>Importando dados da GN1</b>
            <li>Planilha Excel gerada no sistema GN1</li>
            <li>Salvar como...</li>
            <li>Arquivo CSV UTF-8</li>
          </ul>

          <br>

          <ul>
            <b>Planilha de exemplo:</b>
            <li>
              <a
                href='https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/spreadsheets%2Finscricoes%20planilha%20exemplo.xlsx?alt=media&token=d7398d52-9b09-400d-a779-077dfc4c2b56'>
                inscricoes planilha exemplo.xlsx
              </a>
            </li>
          </ul>

          <br>

          <ul>
            <b>Regras para a planilha:</b>
            <li>
              A primeira linha é um cabeçalho. Obrigatório
            </li>
            <li>
              A seguencia de colunas deve ser respeitada.
            </li>
            <li>
              São 16 colunas ao todo.
            </li>
            <li>
              Caso não tenha a informação, deixar a coluna com celulas em branco
            </li>
          </ul>

          <br>

          <ol>
            <b>Colunas</b>
            <li>NUMERO
              <br>
              <i>Sequencial, conta as linhas</i>
            </li>
            <li>NOME
              <br>
              <i>
                O sistema irá garantir as maiusculas e minusculas
              </i>
            </li>
            <li>CATEGORIA
              <br>
              <i>
                A Categoria do associado.Deve ser exatamente igual ao cadastrado
              </i>
            </li>
            <li>FORMA
              <br>
              <i>
                A form de pagamento. Billet para boleto e CreditCard para cartão
              </i>
            </li>
            <li>CARTAO
              <br>
              <i>
                A bandeira do cartão (Visa, Credicard, ...)
              </i>
            </li>
            <li>TRANSACAO
              <br>
              <i>O código da transação de venda executada. Se origem for GN1, usar o código da transação
                GN1. Se Admin deixar vazio</i>
            </li>
            <li>PARCELAS
              <br>
              <i>Boletos são a vista mas cartão pode ser parcelado</i>
            </li>
            <li>DATA PEDIDO
              <br>
              <i>A data a compra</i>
            </li>
            <li>VALOR BRUTO
              <br>
              <i>Valor dem descntos</i>
            </li>
            <li>VALOR LIQUIDO
              <br>
              <i>O valor com descontos</i>
            </li>
            <li>ORIGEM
              <br>
              <i>
                se vier da GN1, origem = GN1. Se realizado pelo admin, origem = Admins
              </i>
            </li>
            <li>CPF
              <br>
              <i>O CPF ou passaporte do asociado</i>
            </li>
            <li>CIDADE
              <br>
              <i>
                A cidade do associado
              </i>
            </li>
            <li>Estado
              <br>
              <i>
                O Estado do associado
              </i>
            </li>
            <li>CELULAR
              <br>
              <i>
                O núnero do celular do associado
              </i>
            </li>
            <li>EMAIL
              <br>
              <i>
                O email do associado
              </i>
            </li>
          </ol>

        </div>

      </div>

    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>cloud_upload</mat-icon>
        <div>Arquivo CSV</div>
      </ng-template>

      <div class='tab-content'>

        <div class='content-file'>

          <input id='selectedFile' style="display: none;" #file type="file" accept='*/pdf'
            (change)="readCSVFile($event)" />
          <button style='color:green;' mat-raised-button onclick="document.getElementById('selectedFile').click();">
            Escolher Arquivo
          </button>


          <div class='panel' style='height:300px;'>
            <hr>
            <div style='color:red;'>Erros</div>
            <ul>
              <li *ngFor="let err of errors; let j = index" style='padding:5px;'>
                {{j+1}} - {{err}}
              </li>
            </ul>

            <hr>
            <div style='color:rgb(4, 87, 180);'>Válidos</div>
            <ul>
              <li *ngFor="let order of orderedList; let i = index" style='padding:5px;'>
                {{i+1}} - {{order.member_name}} - {{order.member_cpf}}
              </li>
            </ul>

          </div>

        </div>


        <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>

          <button mat-raised-button (click)='uploadCSVFile()'>
            <mat-icon class='icon-done'>check_circle_outline</mat-icon>
          </button>

        </div>

      </div>

    </mat-tab>

  </mat-tab-group>


</div>